// src/pages/Faculty/partials/ImportDepartmentModal.jsx
import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, Form, Input, Label } from "reactstrap";
import axios from "axios";

const ImportDepartmentModal = ({ isOpen, toggle, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError("");
  };

  const handleImport = async () => {
    if (!file) {
      setError("Veuillez sélectionner un fichier !");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post("/api/v1/import/department", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setLoading(false);
      toggle(); // ferme le modal
      setFile(null);

      if (onSuccess) onSuccess(response.data);
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.message || "Erreur lors de l'import");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Importer les départements</ModalHeader>
      <ModalBody>
        <Form>
          <Label for="fileInput">Sélectionner un fichier CSV ou XLS/XLSX</Label>
          <Input
            type="file"
            id="fileInput"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleFileChange}
          />
        </Form>
        {error && <p className="text-danger mt-2">{error}</p>}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Annuler
        </Button>
        <Button color="primary" onClick={handleImport} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Importer"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ImportDepartmentModal;
